import moment from "moment-timezone";
import type { Interval } from "../../types/Resource";

export type UnavailableBlock = Omit<Interval, "startDate" | "endDate" | "isAvailable"> & {
    id: string;
    startDate: string;
    endDate: string;
    isAvailable: false;
    available: boolean;
    type: "unavailable";
};

export const processUnavailableBlocks = (intervals: any) => {
    const userTimezone = moment.tz.guess();
    return intervals
        .filter((item) => !item.available)
        .map((item) => ({
            ...item,
            id: item.id || crypto.randomUUID(),
            startDate: moment.parseZone(item.startDate).tz(userTimezone, true).toISOString(true),
            endDate: moment.parseZone(item.endDate).tz(userTimezone, true).toISOString(true),
            type: "unavailable",
        }));
};

// export const processUnavailableBlocks = (unavailable: Interval[]) => {
//     console.log({ unavailable })
//     const userTimezone = moment.tz.guess();
//     // 1. Normalize all items to the target timezone and give them IDs
//     const normalizedItems = unavailable.filter((item: any) => item.isAvailable === item.available).map((item) => ({
//         ...item,
//         id: item.id || crypto.randomUUID(),
//         startDate: moment.parseZone(item.startDate).tz(userTimezone, true),
//         endDate: moment.parseZone(item.endDate).tz(userTimezone, true),
//     }));

//     // 2. Group items by date to handle multiple slots per day
//     const groupedByDay: Record<string, any[]> = {};
//     normalizedItems.forEach(item => {
//         const dateKey = item.startDate.format("YYYY-MM-DD");
//         if (!groupedByDay[dateKey]) groupedByDay[dateKey] = [];
//         groupedByDay[dateKey].push(item);
//     });

//     const finalUnavailableBlocks: UnavailableBlock[] = [];

//     Object.values(groupedByDay).forEach(dayItems => {
//         const availableItems = dayItems.filter(i => i.isAvailable);
//         const explicitUnavailable = dayItems.filter(i => !i.isAvailable);

//         let generatedUnavailable: UnavailableBlock[] = [];

//         if (availableItems.length > 0) {
//             // Check if any available item is "allDay" - if so, no gaps to generate
//             const isAllDayAvailable = availableItems.some(i => i.allDay);

//             if (!isAllDayAvailable) {
//                 // Merge overlapping available slots (e.g., 10-12 and 11-13 becomes 10-13)
//                 const mergedAvailable = mergeIntervals(availableItems.map(i => ({
//                     start: i.startDate,
//                     end: i.endDate
//                 })));

//                 const dayStart = moment(availableItems[0].startDate).startOf("day");
//                 const dayEnd = moment(availableItems[0].startDate).endOf("day");

//                 // Generate gaps: StartOfDay -> First Available, Gaps Between, Last Available -> EndOfDay
//                 let currentPos = dayStart;
//                 mergedAvailable.forEach(range => {
//                     if (range.start.isAfter(currentPos)) {
//                         generatedUnavailable.push(createBlock(currentPos, range.start, dayItems[0]));
//                     }
//                     currentPos = range.end;
//                 });
//                 if (currentPos.isBefore(dayEnd)) {
//                     generatedUnavailable.push(createBlock(currentPos, dayEnd, dayItems[0]));
//                 }
//             }
//         }

//         // 3. Combine explicit "unavailable" items with the generated "gap" blocks
//         const allDayUnavailable = [...explicitUnavailable, ...generatedUnavailable].map(item => ({
//             ...item,
//             startDate: moment.isMoment(item.startDate) ? item.startDate.toISOString(true) : item.startDate,
//             endDate: moment.isMoment(item.endDate) ? item.endDate.toISOString(true) : item.endDate,
//             type: "unavailable",
//             isAvailable: false
//         }));

//         finalUnavailableBlocks.push(...allDayUnavailable);
//     });

//     return finalUnavailableBlocks;
// };

// --- Helpers ---

function createBlock(start: moment.Moment, end: moment.Moment, template: any) {
    return {
        ...template,
        id: crypto.randomUUID(),
        startDate: start.toISOString(true),
        endDate: end.toISOString(true),
        isAvailable: false,
        type: "unavailable"
    };
}

function mergeIntervals(intervals: { start: moment.Moment, end: moment.Moment }[]) {
    if (intervals.length <= 1) return intervals;
    // Sort by start time
    intervals.sort((a, b) => a.start.valueOf() - b.start.valueOf());
    const merged = [intervals[0]];
    for (let i = 1; i < intervals.length; i++) {
        const last = merged[merged.length - 1];
        const current = intervals[i];
        if (current.start.isSameOrBefore(last.end)) {
            if (current.end.isAfter(last.end)) last.end = current.end;
        } else {
            merged.push(current);
        }
    }
    return merged;
}